<template>
  <div
    id="top-bars-container"
    ref="containerRef"
    class="top-bars-container"
    :class="{ 'sidebar-collapsed': sidebarCollapsed }"
  >
    <slot />
  </div>
</template>

<script setup>
// Container pour les bandeaux en haut de page (mise à jour disponible).
// Symétrique de BottomBarsContainer : les bandeaux y sont téléportés, le
// container est toujours monté pour que la cible du Teleport existe.
//
// Il publie sa hauteur dans --top-bars-height, que le contenu de la page
// utilise pour se décaler : un bandeau fixé en haut sans compensation masque
// le début de la page (le défaut de l'ancienne interface).
import { ref, onMounted, onBeforeUnmount } from 'vue'

defineProps({
  sidebarCollapsed: {
    type: Boolean,
    default: false
  }
})

const containerRef = ref(null)
let resizeObserver = null

const updateTopBarsHeight = () => {
  const el = containerRef.value
  if (!el) return
  const hasBars = el.children.length > 0
  const height = hasBars ? Math.round(el.getBoundingClientRect().height) : 0
  document.documentElement.style.setProperty('--top-bars-height', `${height}px`)
}

onMounted(() => {
  updateTopBarsHeight()
  resizeObserver = new ResizeObserver(updateTopBarsHeight)
  resizeObserver.observe(containerRef.value)
})

onBeforeUnmount(() => {
  resizeObserver?.disconnect()
  document.documentElement.style.removeProperty('--top-bars-height')
})
</script>

<style scoped>
.top-bars-container {
  position: fixed;
  top: 0;
  left: var(--sidebar-width);
  right: 0;
  z-index: var(--z-fixed);
  display: flex;
  flex-direction: column; /* Le premier bandeau annoncé reste le plus haut */
  gap: var(--spacing-sm);
  padding: var(--spacing-sm);
  pointer-events: none; /* Permet les clics à travers, sauf sur les enfants */
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Rail de la barre repliée : 96 px. */
.top-bars-container.sidebar-collapsed {
  left: 96px;
}

.top-bars-container > * {
  pointer-events: auto; /* Réactive les clics sur les enfants */
}

@media (max-width: 768px) {
  .top-bars-container {
    left: 0;
  }
}
</style>
